import { render, staticRenderFns } from "./SwitchSetting.vue?vue&type=template&id=32c40ea2&scoped=true"
import script from "./SwitchSetting.vue?vue&type=script&lang=js"
export * from "./SwitchSetting.vue?vue&type=script&lang=js"
import style0 from "./SwitchSetting.vue?vue&type=style&index=0&id=32c40ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c40ea2",
  null
  
)

export default component.exports